import { render, staticRenderFns } from "./isr-porel-pago-del-finiquito-porel-retiro-voluntario.vue?vue&type=template&id=a25cf8b0&lang=html&"
import script from "./isr-porel-pago-del-finiquito-porel-retiro-voluntario.vue?vue&type=script&lang=js&"
export * from "./isr-porel-pago-del-finiquito-porel-retiro-voluntario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports